import { instance } from './axios'

/**
 * These next methods are retrieving the acceptance of the terms of service
 */

/**
 *
 * @param int user_id
 * @returns boolean
 */
// TODO: use access token instead
export const termsAcceptance = async user_id => {
  return instance.get(`/terms/${user_id}`)
}

/**
 *
 * @param object payload
 * @returns void
 */
export const acceptTerms = async payload => {
  return instance.post(`/terms`, payload)
}

export const getAllUsers = async () => {
  return instance.get(`/user`)
}
